import {HistInfo, HistInfoMeta} from "../../core/gb-api";


export function isGestrichen(histInfo: HistInfo) {
  const state = extractGestrichenState(histInfo);
  return state ? true : false;
}

export function extractGestrichenState(histInfo: HistInfo) {
  switch (histInfo.histEnum) {
    case "VON_RECHTGUELTIG_BIS_AKTUELL":
    case "VON_RECHTGUELTIG_BIS_VERKNUEPFT":
    case "VON_RECHTGUELTIG_BIS_VORGAENGIG":
    case "VON_RECHTGUELTIG_BIS_RECHTSGUELTIG":
    case "VON_VORGAENGIG_BIS_AKTUELL":
    case "VON_VORGAENGIG_BIS_VERKNUPEFT":
    case "VON_VORGAENGIG_BIS_VORGAENGER":
    case "VON_VERKNUEPFT_BIS_AKTUELL":
    case "VON_VERKNUEPFT_BIS_VERKNUEPFT":
    case "VON_AKTUELL_BIS_AKTUELL":
      return histInfo.histEnum;
    default:
      return undefined;
  }
}

export function calculateParallelHistInfos(histInfos: HistInfoMeta[]): HistInfoMeta {
  if (!histInfos || histInfos.length < 1) {
    throw new Error("At least one HistInfo object is required.");
  }
  let calculatedHistInfo: HistInfoMeta = {
    histEnum: histInfoOrderParalel[histInfoOrderParalel.length - 1]
  };
  for (const histInfo of histInfos) {
    const currentIndex = histInfoOrderParalel.indexOf(calculatedHistInfo.histEnum);
    const iterationIndex = histInfoOrderParalel.indexOf(histInfo.histEnum);
    if (iterationIndex <= currentIndex) {
      calculatedHistInfo = histInfo;
    }
  }
  return calculatedHistInfo;
}

export function calculateSerialHistInfos(histInfos: HistInfoMeta[]): HistInfoMeta {
  if (!histInfos || histInfos.length < 1) {
    throw new Error("At least one HistInfo object is required.");
  }
  let calculatedHistInfo: HistInfoMeta = {
    histEnum: histInfoOrderSerial[histInfoOrderSerial.length - 1]
  };
  for (const histInfo of histInfos) {
    const currentIndex = histInfoOrderSerial.indexOf(calculatedHistInfo.histEnum);
    const iterationIndex = histInfoOrderSerial.indexOf(histInfo.histEnum);
    if (iterationIndex <= currentIndex) {
      calculatedHistInfo = histInfo;
    }
  }
  return calculatedHistInfo;
}

const histInfoOrderParalel = new Array<HistInfoMeta.HistEnumEnum>();
histInfoOrderParalel.push("ILLEGALER_ZUSTAND");
histInfoOrderParalel.push("ERSTERFASSUNG");

// schwarz
histInfoOrderParalel.push("VON_RECHTGUELTIG_BIS_NULL");

// grün
histInfoOrderParalel.push("VON_AKTUELL_BIS_NULL");
histInfoOrderParalel.push("VON_VORGAENGIG_BIS_NULL");
histInfoOrderParalel.push("VON_VERKNUEPFT_BIS_NULL");

// rot
histInfoOrderParalel.push("VON_AKTUELL_BIS_AKTUELL");
histInfoOrderParalel.push("VON_VORGAENGIG_BIS_AKTUELL");
histInfoOrderParalel.push("VON_RECHTGUELTIG_BIS_AKTUELL");
histInfoOrderParalel.push("VON_VERKNUEPFT_BIS_AKTUELL");

histInfoOrderParalel.push("VON_VORGAENGIG_BIS_VERKNUPEFT");
histInfoOrderParalel.push("VON_RECHTGUELTIG_BIS_VERKNUEPFT");
histInfoOrderParalel.push("VON_VERKNUEPFT_BIS_VERKNUEPFT");

histInfoOrderParalel.push("VON_RECHTGUELTIG_BIS_VORGAENGIG");
histInfoOrderParalel.push("VON_VORGAENGIG_BIS_VORGAENGER");

histInfoOrderParalel.push("VON_RECHTGUELTIG_BIS_RECHTSGUELTIG");

const histInfoOrderSerial = histInfoOrderParalel.slice().reverse();


